import { render } from "./Create.vue?vue&type=template&id=636aa3ac"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Users/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "636aa3ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('636aa3ac', __exports__)) {
    console.log('reload')
    api.reload('636aa3ac', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=636aa3ac", () => {
    console.log('re-render')
    api.rerender('636aa3ac', render)
  })

}


export default __exports__